export const PARTNER_L10N = {
  fr: {
    toggle: 'Devenir partenaire', badge: 'Candidature partenariat', heading: 'Devenir Partenaire',
    sub: "Opérateurs logistiques, coopératives, acteurs ESS — rejoignez l'écosystème KDMARCHÉ × O'SCOP en tant que partenaire officiel.",
    type: 'Type de partenariat *', typePh: 'Choisissez un type de partenariat',
    company: 'Raison sociale', companyPh: 'Nom légal de votre entreprise',
    legal: 'Statut juridique', legalPh: 'Sélectionnez un statut',
    name: 'Nom complet *', namePh: 'Jean Dupont',
    email: 'Email professionnel *', emailPh: 'contact@entreprise.fr',
    phone: 'Téléphone', country: 'Pays', project: 'Votre projet',
    projectPh: 'Décrivez votre activité et le partenariat envisagé…',
    submit: 'Envoyer ma candidature', sending: 'Envoi en cours…',
    disclaimer: 'Votre candidature est étudiée par la coopérative — réponse sous 48 h ouvrées.',
    successTitle: 'Candidature transmise !',
    successText: 'Merci ! Votre candidature a bien été transmise à la coopérative — un accusé de réception détaillé vous a été envoyé par email.',
    toastOk: 'Candidature envoyée — nous revenons vers vous rapidement', toastErr: "Erreur lors de l'envoi",
  },
  en: {
    toggle: 'Become a partner', badge: 'Partnership application', heading: 'Become a Partner',
    sub: 'Logistics operators, cooperatives, SSE actors — join the KDMARCHÉ × O\u2019SCOP ecosystem as an official partner.',
    type: 'Partnership type *', typePh: 'Choose a partnership type',
    company: 'Company name', companyPh: 'Legal name of your company',
    legal: 'Legal status', legalPh: 'Select a status',
    name: 'Full name *', namePh: 'John Smith',
    email: 'Business email *', emailPh: 'contact@company.com',
    phone: 'Phone', country: 'Country', project: 'Your project',
    projectPh: 'Describe your activity and the partnership you have in mind…',
    submit: 'Send my application', sending: 'Sending…',
    disclaimer: 'Your application is reviewed by the cooperative — reply within 48 business hours.',
    successTitle: 'Application sent!',
    successText: 'Thank you! Your application has been sent to the cooperative — a detailed acknowledgement has been emailed to you.',
    toastOk: 'Application sent — we will get back to you shortly', toastErr: 'Error while sending',
  },
  es: {
    toggle: 'Hacerse socio', badge: 'Candidatura de asociación', heading: 'Hacerse Socio',
    sub: 'Operadores logísticos, cooperativas, actores de la ESS — únase al ecosistema KDMARCHÉ × O\u2019SCOP como socio oficial.',
    type: 'Tipo de asociación *', typePh: 'Elija un tipo de asociación',
    company: 'Razón social', companyPh: 'Nombre legal de su empresa',
    legal: 'Forma jurídica', legalPh: 'Seleccione una forma',
    name: 'Nombre completo *', namePh: 'Juan Pérez',
    email: 'Correo profesional *', emailPh: 'contacto@empresa.es',
    phone: 'Teléfono', country: 'País', project: 'Su proyecto',
    projectPh: 'Describa su actividad y la asociación prevista…',
    submit: 'Enviar mi candidatura', sending: 'Enviando…',
    disclaimer: 'La cooperativa estudia su candidatura — respuesta en 48 horas laborables.',
    successTitle: '¡Candidatura enviada!',
    successText: '¡Gracias! Su candidatura ha sido transmitida a la cooperativa — se le ha enviado un acuse de recibo detallado por correo.',
    toastOk: 'Candidatura enviada — le responderemos en breve', toastErr: 'Error durante el envío',
  },
  gcf: {
    toggle: 'Vin patnè', badge: 'Kandidati patenarya', heading: 'Vin Patnè',
    sub: 'Opératè lojistik, koopérativ, aktè ESS — antré adan ékosistèm KDMARCHÉ × O\u2019SCOP kon patnè ofisyèl.',
    type: 'Kalité patenarya *', typePh: 'Chwazi on kalité patenarya',
    company: 'Rézon sosyal', companyPh: "Non légal a antrépriz a'w",
    legal: 'Stati jiridik', legalPh: 'Chwazi on stati',
    name: 'Non konplè *', namePh: 'Jan Dupont',
    email: 'Imel pwofésyonèl *', emailPh: 'contact@entreprise.fr',
    phone: 'Téléfòn', country: 'Péyi', project: "Pwojé a'w",
    projectPh: "Èspliké aktivité a'w é patenarya ou anvi…",
    submit: 'Voyé kandidati an mwen', sending: 'Voyé ka fèt…',
    disclaimer: "Koopérativ-la ka étidyé kandidati a'w — répons avan 48 tè ouvrab.",
    successTitle: "Kandidati a'w pati !",
    successText: "Mèsi ! Kandidati a'w byen rivé adan koopérativ-la — on akizé résepsyon détayé voyé ba'w pa imel.",
    toastOk: "Kandidati voyé — nou ké viré vin' vè'w byen vit", toastErr: 'On pwoblenm pandan voyé-la',
  },
  ar: {
    toggle: 'كن شريكاً', badge: 'طلب شراكة', heading: 'كن شريكاً',
    sub: 'مشغلو الخدمات اللوجستية والتعاونيات وفاعلو الاقتصاد الاجتماعي والتضامني — انضموا إلى منظومة KDMARCHÉ × O\u2019SCOP كشريك رسمي.',
    type: 'نوع الشراكة *', typePh: 'اختر نوع الشراكة',
    company: 'الاسم القانوني', companyPh: 'الاسم القانوني لشركتك',
    legal: 'الشكل القانوني', legalPh: 'اختر شكلاً قانونياً',
    name: 'الاسم الكامل *', namePh: 'محمد أحمد',
    email: 'البريد الإلكتروني المهني *', emailPh: 'contact@company.com',
    phone: 'الهاتف', country: 'البلد', project: 'مشروعك',
    projectPh: 'صف نشاطك والشراكة المنشودة…',
    submit: 'إرسال طلبي', sending: 'جارٍ الإرسال…',
    disclaimer: 'تدرس التعاونية طلبك — الرد خلال 48 ساعة عمل.',
    successTitle: 'تم إرسال الطلب!',
    successText: 'شكراً! تم إرسال طلبك إلى التعاونية — وقد أُرسل إليك إشعار استلام مفصّل عبر البريد الإلكتروني.',
    toastOk: 'تم إرسال الطلب — سنعاود الاتصال بك قريباً', toastErr: 'خطأ أثناء الإرسال',
  },
};

export const partnerLang = (l) => (l?.startsWith('gcf') ? 'gcf' : (l || 'fr').slice(0, 2));
